// import fieldLabels from './fieldLabels'

export default [
  {
    title: '',
    field: 'edit_button',
    hozAlign: 'center',
    frozen: true,
    headerSort: false,
    minWidth: 50,
    width: 50,
    formatter: function (cell, formatterParams, onRendered) {
      return '<span class="icon icon-pencil"></span>'
    }
  },
  {
    title: 'Target Date',
    field: 'publish_date',
    sorter: 'date',
    cellDblClick: function (e, cell) {
    },
    cellDblClickDescription: ''

  },
  {
    title: 'Mapped URL',
    field: 'url',
    sorter: 'string',
    headerFilter: 'input',
    headerFilterFunc: 'Containing',
    cellDblClick: function (e, cell) {
      const row = cell.getRow()
      const publishedUrl = row.getCell('published_url').getValue()
      const value = publishedUrl || cell._cell.value
      window.open(value, '_blank');
    },
    cellDblClickDescription: 'double-click cell to open URL in new tab',
    formatter: function (cell) {
      cell.getElement().setAttribute('private-content', true)
      return cell.getValue()
    }
  },
  {
    title: 'Published URL',
    field: 'published_url',
    sorter: 'string',
    headerFilter: 'input',
    headerFilterFunc: 'Containing',
    cellDblClick: function (e, cell) {
      window.open(cell._cell.row.data.published_url, '_blank');
    },
    cellDblClickDescription: 'double-click cell to open URL in new tab',
    formatter: function (cell) {
      cell.getElement().setAttribute('private-content', true)
      return cell.getValue()
    }
  },
  {
    visible: false,
    title: 'Resolving URL',
    field: 'http_response_url',
    sorter: 'string',
    headerFilter: 'input',
    headerFilterFunc: 'Containing'
  },
  {
    visible: false,
    title: 'Response Code',
    field: 'http_response_code',
    sorter: 'string',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    }
  },
  {
    title: 'URL Status',
    field: 'url_status',
    sorter: 'string',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    },
    editor: 'autocomplete',
    editorParams: {
      showListOnEmpty: true,
      freetext: false
      // values:url_statuses
    },
    cellDblClick: function (e, cell) {
    },
    cellDblClickDescription: ''
  },
  {
    title: 'Brief Status',
    field: 'content_brief_status',
    sorter: 'string',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    },
    cellDblClick: function (e, cell) {
      window.open('/content_brief/client_link?id=' + cell._cell.row.data.fk_content_brief_id, '_blank').focus()
    },
    cellDblClickDescription: 'double-click cell to open content brief in new tab',
    editor: 'autocomplete',
    editorParams: {
      showListOnEmpty: true,
      freetext: false,
      values: []
    }
  },
  {
    title: 'Section',
    field: 'section_name',
    sorter: 'string',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    },
    editor: 'autocomplete',
    editorParams: {
      showListOnEmpty: true,
      freetext: false,
      values: {}
    },
    cellDblClick: function (e, cell) {
    },
    cellDblClickDescription: ''

  },
  {
    title: 'Page Type',
    field: 'page_type',
    sorter: 'string',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    },
    editor: 'autocomplete',
    editorParams: {
      showListOnEmpty: true,
      freetext: false
      // values: page_types
    },
    cellDblClick: function (e, cell) {
    },
    cellDblClickDescription: ''

  },
  {
    title: 'KW Count',
    field: 'keyword_count',
    sorter: 'string',
    headerFilter: 'input',
    headerFilterFunc: '=',
    topCalc: 'sum',
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    },
    cellDblClick: function (e, cell) {
    },
    cellDblClickDescription: 'double-click cell to open keyword census in new tab'
  },
  {
    title: 'URL Optimized',
    field: 'is_optimized',
    sorter: 'string',
    headerFilter: 'input',
    headerFilterFunc: 'Containing',
    editor: 'select',
    editorParams: {
      values: {
        'Yes': 'Yes',
        'No': 'No'
      }
    }
  },
  {
    title: 'MSV 1',
    field: 'msv_1_total',
    sorter: 'string',
    headerFilter: 'input',
    headerFilterFunc: '=',
    topCalc: 'sum',
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    },
    cellDblClick: function (e, cell) {
    },
    cellDblClickDescription: ''

  },
  // ---------- DEFAULT COLUMNS ^^
  {
    visible: false,
    title: 'MSV 2',
    field: 'msv_2_total',
    headerFilter: 'input',
    headerFilterFunc: '=',
    sorter: 'string',
    topCalc: 'sum',
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    },
    cellDblClick: function (e, cell) {
    },
    cellDblClickDescription: ''

  },
  {
    visible: false,
    title: 'MSV 3',
    field: 'msv_3_total',
    headerFilter: 'input',
    headerFilterFunc: '=',
    sorter: 'string',
    topCalc: 'sum',
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    },
    cellDblClick: function (e, cell) {
    },
    cellDblClickDescription: ''

  },
  {
    visible: false,
    title: 'MSV 4',
    field: 'msv_4_total',
    headerFilter: 'input',
    headerFilterFunc: '=',
    sorter: 'string',
    topCalc: 'sum',
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    },
    cellDblClick: function (e, cell) {
    },
    cellDblClickDescription: ''

  },
  {
    visible: false,
    title: 'Links',
    field: 'link_count',
    headerFilter: 'input',
    headerFilterFunc: '=',
    sorter: 'string',
    topCalc: 'sum',
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    },
    cellDblClickDescription: 'double-click cell to open link manager in new tab'
  },
  {
    visible: false,
    title: 'Average Rel Score',
    field: 'keyword_score_average',
    headerFilter: 'input',
    headerFilterFunc: '=',
    sorter: 'string'
  },
  {
    visible: false,
    title: 'Writing Status',
    field: 'writing_status',
    sorter: 'string',
    width: 50,
    headerSortStartingDir: 'asc',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    },
    resizable: true,
    editor: 'autocomplete',
    editorParams: {
      showListOnEmpty: true,
      freetext: false
    }
  },
  {
    visible: false,
    title: 'Writer',
    field: 'assigned_writer',
    sorter: 'string',
    width: 150,
    headerSortStartingDir: 'asc',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    },
    resizable: true,
    editor: 'autocomplete',
    editorParams: {
      showListOnEmpty: true,
      freetext: false,
      values: []
    },
    formatter: function (cell) {
      cell.getElement().setAttribute('private-content', true)
      return cell.getValue()
    }
  },
  {
    visible: false,
    title: 'Strategist',
    field: 'assigned_strategist',
    sorter: 'string',
    width: 150,
    headerSortStartingDir: 'asc',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    },
    resizable: true,
    editor: 'autocomplete',
    editorParams: {
      showListOnEmpty: true,
      freetext: false,
      values: []
    },
    formatter: function (cell) {
      cell.getElement().setAttribute('private-content', true)
      return cell.getValue()
    }
  }
]
